module.exports = __webpack_public_path__ + "static/media/ZSonnenberg_photo.676c6deb.jpg";